import _initializerDefineProperty from "@babel/runtime-corejs3/helpers/initializerDefineProperty";
import _applyDecoratedDescriptor from "@babel/runtime-corejs3/helpers/applyDecoratedDescriptor";
import _initializerWarningHelper from "@babel/runtime-corejs3/helpers/initializerWarningHelper";
var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _dec7, _dec8, _dec9, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9;
import Cookies from 'js-cookie';
import { action, computed, extendObservable, observable, runInAction } from 'mobx';
import { ShoppingClient } from '@udemy/shopping';
import { udLink } from '@udemy/ud-data';
import { isRolePlayEnabled, isAggregatorEnabled, isAcademiesEnabled, isLearnAINavigationEnabled, isSplitNavByCategoriesEnabled } from './external/header-experiment-features';
import { GROW_WITH_GOOGLE_PRODUCT_TYPES, VALUE_PLAN_PRODUCT_TYPES } from './utils/subscription-constants';
import { fetchSubscriptionInfo } from './utils/subscription-utils';
export let HeaderStore = (_dec = observable.ref, _dec2 = observable.ref, _dec3 = observable.ref, _dec4 = observable.ref, _dec5 = observable.ref, _dec6 = observable.ref, _dec7 = observable.ref, _dec8 = observable.ref, _dec9 = observable.ref, _class = class HeaderStore {
  /**
   * See props in get_ud_header_react_app_props
   * for appProps structure.
   */
  constructor(props) {
    var _props$shoppingClient;
    this.isInstructorSignupEnabled = void 0;
    this.mobileAppLink = void 0;
    this.shoppingClient = void 0;
    this.tryUFBPlacements = void 0;
    /**
     * UFB context for Udemy Business features. This is observable so that computed values
     * depending on it (such as URLs) will update reactively if it changes after store creation.
     */
    _initializerDefineProperty(this, "ufbContext", _descriptor, this);
    /**
     * See ud_header in user_specific_ud_header_context
     * for userSpecificContext structure.
     */
    _initializerDefineProperty(this, "userSpecificContext", _descriptor2, this);
    _initializerDefineProperty(this, "formActionParams", _descriptor3, this);
    _initializerDefineProperty(this, "isPersonalPlanSubscriber", _descriptor4, this);
    _initializerDefineProperty(this, "showCartDropdown", _descriptor5, this);
    _initializerDefineProperty(this, "enableCartOnMobileNav", _descriptor6, this);
    _initializerDefineProperty(this, "showInstructorDropdown", _descriptor7, this);
    _initializerDefineProperty(this, "enrolledProductType", _descriptor8, this);
    _initializerDefineProperty(this, "isEligibleForGrowWithGoogleUpgrade", _descriptor9, this);
    this.isFeaturedQuestionsEnabled = void 0;
    this.isPayoutSettingsEnabled = void 0;
    this.isRevenueReportEnabled = void 0;
    this.isInstructorAIAssistantInsightsEnabled = false;
    this.isDisplayCodingExerciseInsights = false;
    this.isInPracticeTestInsightsTargetGroup = false;
    this.isContentFreshnessEnabled = false;
    this.isInstructorSignupEnabled = props.isInstructorSignupEnabled;
    this.mobileAppLink = props.mobileAppLink;
    this.shoppingClient = (_props$shoppingClient = props.shoppingClient) !== null && _props$shoppingClient !== void 0 ? _props$shoppingClient : ShoppingClient;
    this.tryUFBPlacements = props.tryUFBPlacements;
    this.ufbContext = props.ufbContext;
  }
  get notificationBadgeContext() {
    var _user$num_unread_qa, _user$num_unread_feat, _Cookies$get, _this$ufbContext;
    const {
      user
    } = this.userSpecificContext;
    const context = {
      unreadActivityNotifications: user ? user.num_of_unread_activity_notifications : 0,
      unreadMessages: user ? user.num_unread_threads : 0,
      unreadQA: user ? (_user$num_unread_qa = user.num_unread_qa) !== null && _user$num_unread_qa !== void 0 ? _user$num_unread_qa : 0 : 0,
      unreadFeaturedQuestions: user ? (_user$num_unread_feat = user.num_unread_featured_questions) !== null && _user$num_unread_feat !== void 0 ? _user$num_unread_feat : 0 : 0,
      unseenCredits: parseInt((_Cookies$get = Cookies.get('ud_credit_unseen')) !== null && _Cookies$get !== void 0 ? _Cookies$get : '0', 10),
      cartBuyables: 0,
      unreadAlerts: 0
    };
    if (this.shoppingClient) {
      context.cartBuyables = this.shoppingClient.lists.cart.items.length;
    } else {
      context.cartBuyables = 0;
    }
    Object.assign(context, ((_this$ufbContext = this.ufbContext) === null || _this$ufbContext === void 0 ? void 0 : _this$ufbContext.badgeContext) || {});
    Object.values(context).forEach(count => {
      context.unreadAlerts += count;
    });
    return context;
  }
  get signupParams() {
    if (this.isInstructorSignupEnabled) {
      return {
        showInstructorSignup: true,
        popupTrackingIdentifier: 'bai_header',
        nextPath: this.urls.INSTRUCTOR_ONBOARDING
      };
    }
    return {};
  }
  get urls() {
    var _this$ufbContext2, _this$ufbContext2$url;
    const {
      isInstructor
    } = this.userSpecificContext;
    const ufburls = (_this$ufbContext2 = this.ufbContext) === null || _this$ufbContext2 === void 0 || (_this$ufbContext2$url = _this$ufbContext2.urls) === null || _this$ufbContext2$url === void 0 ? void 0 : _this$ufbContext2$url.call(_this$ufbContext2, isInstructor);
    return {
      BROWSE: '/',
      SEARCH: '/courses/search/',
      SEARCH_SUGGESTIONS: '/search-suggestions/',
      TEACH: isInstructor ? '/instructor/' : '/teaching/?ref=teach_header',
      MY_LEARNING: '/home/my-courses/',
      MY_ACTIVITY: '/learner-activity/',
      MY_PROGRAMS: '/home/my-courses/programs/',
      MY_COURSES: '/home/my-courses/learning/',
      PREMIUM_COURSES: '/home/my-courses/premium/',
      WISHLIST: '/home/my-courses/wishlist/',
      CART: '/cart/',
      VIEW_NOTIFICATIONS: isInstructor ? '/instructor/user/view-notifications/' : '/user/view-notifications/',
      EDIT_NOTIFICATIONS: isInstructor ? '/instructor/account/notifications/' : '/user/edit-notifications/',
      MESSAGES: '/message/',
      INVITE: '/invite/',
      PAYMENT_METHODS: '/user/edit-payment-methods/',
      CREDITS: '/dashboard/credit-history/',
      PURCHASE_HISTORY: '/dashboard/purchase-history/',
      SUBSCRIPTION_MANAGEMENT: '/user/manage-subscriptions/',
      SUPPORT: '/support/',
      ACCOUNT: isInstructor ? '/instructor/account/security/' : '/user/edit-account/',
      EDIT_PROFILE: isInstructor ? '/instructor/profile/basic-information/' : '/user/edit-profile/',
      INSTRUCTOR_ONBOARDING: '/home/teaching/onboarding/teaching-experience/',
      PLANS_AND_PRICING: '/pricing',
      PERSONAL_PLAN: '/personal-plan',
      AI_ASSISTANT: '/ai-assistant/',
      COACHING_BOOKINGS: '/user/coaching/bookings/',
      ...(ufburls !== null && ufburls !== void 0 ? ufburls : {})
    };
  }
  get instructorURLs() {
    return {
      ...this.urls,
      COMMUNITY: udLink.toInstructorCommunity(),
      TEST_VIDEO: '/home/teaching/test-video/',
      API_CLIENTS: '/instructor/account/api/',
      CLOSE_ACCOUNT: '/instructor/account/close/',
      EDIT_NOTIFICATIONS: '/instructor/account/notifications/',
      ACCOUNT: '/instructor/account/security/',
      AI_ASSISTANT_INSIGHTS: '/instructor/communication/ai-assistant-insights/',
      ANNOUNCEMENTS: '/instructor/communication/announcements/',
      ASSIGNMENTS: '/instructor/communication/assignments/',
      FEATURED_QUESTIONS: '/instructor/communication/featured_questions/',
      MESSAGES: '/instructor/communication/messages/',
      Q_AND_A: '/instructor/communication/qa/',
      COURSES: '/instructor/courses/',
      MARKETPLACE_INSIGHTS: '/instructor/marketplace-insights/',
      EDIT_PROFILE: '/instructor/profile/basic-information/',
      EDIT_PHOTO: '/instructor/profile/photo/',
      EDIT_PRIVACY: '/instructor/profile/privacy/',
      PAYOUT_SETTINGS: '/instructor/user/edit-instructor-info/',
      VIEW_NOTIFICATIONS: '/instructor/user/view-notifications/',
      INSIGHTS: '/instructor/insights/',
      REVENUE_REPORT: '/revenue-report/',
      PAYOUT_REPORT: '/payout-report/dashboard/',
      SUPPORT: '/support/?type=instructor',
      TEACH_HUB: '/udemy-teach-hub/?ref=teach_header',
      COACHING: '/instructor/coaching/'
    };
  }
  get isAcademiesFeatureEnabled() {
    return isAcademiesEnabled({
      headerExperimentFeatures: this.userSpecificContext.headerExperimentFeatures,
      headerStore: this
    });
  }
  get isAggregatorFeatureEnabled() {
    return isAggregatorEnabled({
      headerExperimentFeatures: this.userSpecificContext.headerExperimentFeatures,
      headerStore: this
    });
  }
  get isLearnAINavigationFeatureEnabled() {
    return isLearnAINavigationEnabled({
      headerExperimentFeatures: this.userSpecificContext.headerExperimentFeatures,
      headerStore: this
    });
  }
  get isSplitNavByCategoriesEnabled() {
    return isSplitNavByCategoriesEnabled({
      headerExperimentFeatures: this.userSpecificContext.headerExperimentFeatures,
      headerStore: this
    });
  }
  get isRolePlayFeatureEnabled() {
    return isRolePlayEnabled({
      headerExperimentFeatures: this.userSpecificContext.headerExperimentFeatures,
      headerStore: this
    });
  }
  get isGrowWithGoogleSubscriber() {
    if (this.enrolledProductType === undefined) {
      return undefined;
    }
    if (this.enrolledProductType === null) {
      return false;
    }
    return GROW_WITH_GOOGLE_PRODUCT_TYPES.includes(this.enrolledProductType);
  }
  get isValuePlanSubscriber() {
    if (this.enrolledProductType === undefined) {
      return undefined;
    }
    if (this.enrolledProductType === null) {
      return false;
    }
    return VALUE_PLAN_PRODUCT_TYPES.includes(this.enrolledProductType);
  }

  /**
   * Computed property that determines if Grow with Google navigation should be shown.
   *
   * Navigation is shown when:
   * 1. User is NOT part of an organization (ufbContext is undefined), AND
   * 2. gwgAcceleratorsNav has items, AND
   * 3. One of the following:
   *    a. Non-subscriber eligible for GWG upgrade, OR
   *    b. Subscriber eligible for GWG upgrade, OR
   *    c. Subscriber already on a GWG plan
   *
   * NEVER shown for organization users (ufbContext defined).
   */
  get isGrowWithGoogleNavigationEnabled() {
    var _this$userSpecificCon, _this$userSpecificCon2, _this$userSpecificCon3, _this$userSpecificCon4;
    // Never show for organization users
    if (this.ufbContext) {
      return false;
    }

    // Must have navigation items
    const hasGwgNav = ((_this$userSpecificCon = (_this$userSpecificCon2 = this.userSpecificContext.gwgAcceleratorsNav) === null || _this$userSpecificCon2 === void 0 ? void 0 : _this$userSpecificCon2.length) !== null && _this$userSpecificCon !== void 0 ? _this$userSpecificCon : 0) > 0;
    if (!hasGwgNav) {
      return false;
    }
    const isConsumerSubscriber = (_this$userSpecificCon3 = (_this$userSpecificCon4 = this.userSpecificContext.user) === null || _this$userSpecificCon4 === void 0 ? void 0 : _this$userSpecificCon4.consumer_subscription_active) !== null && _this$userSpecificCon3 !== void 0 ? _this$userSpecificCon3 : false;
    if (!isConsumerSubscriber) {
      // Non-subscriber: show if eligible for GWG upgrade
      return this.isEligibleForGrowWithGoogleUpgrade;
    } else {
      // Subscriber: show if already on GWG OR eligible for GWG upgrade
      return this.isGrowWithGoogleSubscriber || this.isEligibleForGrowWithGoogleUpgrade;
    }
  }

  /**
   * Fetches the user's subscription information
   *
   * This method populates:
   * - enrolledProductType: The user's subscription product type (used by computed isGrowWithGoogleSubscriber/isValuePlanSubscriber)
   * - isEligibleForGrowWithGoogleUpgrade: Whether user can upgrade to a GWG plan
   *
   * Badge logic in UserProfileDropdown:
   * - enrolledProductType starts as undefined to prevent flash of content before data loads
   * - Show "Personal Plan" badge only if:
   *          consumer_subscription_active === true AND
   *          isGrowWithGoogleSubscriber === false AND
   *          isValuePlanSubscriber === false (data loaded, not GWG/ValuePlan)
   *
   * Navigation logic (see isGrowWithGoogleNavigationEnabled):
   * - Non-subscribers: show if eligible for GWG upgrade
   * - Subscribers: show if already on GWG OR eligible for GWG upgrade
   *
   * This method is called for all non-organization users (both logged-in and logged-out).
   *
   * Note: For logged-out users, currentSubscriptionEnrollment will return an authentication error,
   * but subscriptionPlanUpgradesByProductFamily will still return available plans. The fetcher uses
   * ErrorPolicy.ALLOW_PARTIAL to handle this gracefully and return the partial data.
   */
  async fetchSubscriptionInfo() {
    const isNotOrganizationUser = !this.ufbContext;
    if (isNotOrganizationUser) {
      var _this$userSpecificCon5;
      const isLoggedIn = (_this$userSpecificCon5 = this.userSpecificContext.isLoggedIn) !== null && _this$userSpecificCon5 !== void 0 ? _this$userSpecificCon5 : false;
      const info = await fetchSubscriptionInfo(isLoggedIn);
      runInAction(() => {
        var _info$enrolledProduct;
        // Use null to indicate "loaded but no subscription" vs undefined for "not loaded"
        this.enrolledProductType = (_info$enrolledProduct = info.enrolledProductType) !== null && _info$enrolledProduct !== void 0 ? _info$enrolledProduct : null;
        this.isEligibleForGrowWithGoogleUpgrade = info.isEligibleForGrowWithGoogleUpgrade;
      });
    } else {
      // Organization users - no consumer subscription features
      this.enrolledProductType = null;
      this.isEligibleForGrowWithGoogleUpgrade = false;
    }
  }
  setUserSpecificContext(context) {
    if (context.user) {
      const {
        num_of_unread_activity_notifications,
        ...user
      } = context.user;
      extendObservable(user, {
        num_of_unread_activity_notifications
      });
      context.user = user;
      if (context.user.consumer_subscription_active) {
        this.isPersonalPlanSubscriber = true;
        this.formActionParams = this.formActionParams;
        this.showCartDropdown = false;
        this.enableCartOnMobileNav = true;
        this.showInstructorDropdown = !!context.isInstructor;
      }
    }
    this.userSpecificContext = context;
  }

  /**
   * Sets the UFB context after store creation. This will update any computed values
   * that depend on ufbContext, such as URLs.
   * @param ufbContext The new UFB context or undefined
   */
  setUfbContext(ufbContext) {
    this.ufbContext = ufbContext;
  }

  // Implement in subclasses
  getInstructorPerformancePaths() {
    throw new Error('Not implemented');
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "ufbContext", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "userSpecificContext", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return {};
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "formActionParams", [_dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return {
      src: 'ukw'
    };
  }
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "isPersonalPlanSubscriber", [_dec4], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "showCartDropdown", [_dec5], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return true;
  }
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "enableCartOnMobileNav", [_dec6], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "showInstructorDropdown", [_dec7], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return true;
  }
}), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "enrolledProductType", [_dec8], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return undefined;
  }
}), _descriptor9 = _applyDecoratedDescriptor(_class.prototype, "isEligibleForGrowWithGoogleUpgrade", [_dec9], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _applyDecoratedDescriptor(_class.prototype, "notificationBadgeContext", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "notificationBadgeContext"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "urls", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "urls"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "instructorURLs", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "instructorURLs"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isAcademiesFeatureEnabled", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "isAcademiesFeatureEnabled"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isAggregatorFeatureEnabled", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "isAggregatorFeatureEnabled"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isLearnAINavigationFeatureEnabled", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "isLearnAINavigationFeatureEnabled"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isSplitNavByCategoriesEnabled", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "isSplitNavByCategoriesEnabled"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isRolePlayFeatureEnabled", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "isRolePlayFeatureEnabled"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isGrowWithGoogleSubscriber", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "isGrowWithGoogleSubscriber"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isValuePlanSubscriber", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "isValuePlanSubscriber"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isGrowWithGoogleNavigationEnabled", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "isGrowWithGoogleNavigationEnabled"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "fetchSubscriptionInfo", [action], Object.getOwnPropertyDescriptor(_class.prototype, "fetchSubscriptionInfo"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "setUserSpecificContext", [action], Object.getOwnPropertyDescriptor(_class.prototype, "setUserSpecificContext"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "setUfbContext", [action], Object.getOwnPropertyDescriptor(_class.prototype, "setUfbContext"), _class.prototype), _class);
//# sourceMappingURL=header.mobx-store.js.map